import React from "react"
import { useState, useEffect } from "react"
import { Upload } from "@progress/kendo-react-upload";
import { alertService } from '../../services/helpers/alert.service';
import { optionService } from '../../services/api/option.service';

export const CustomUpload = (props) => {
    const { value, multiple, hideInfo, onChange, ...others } = props;

    const [allowedExtensions, setAllowedExtensions] = useState([]);
    const [displayExtensions, setDisplayExtensions] = useState([]);
    const [maxFileSize, setMaxFileSize] = useState(0);


    useEffect(() => {
        optionService.getUploadOptions()
            .then(response => {
                if (response?.allowedExtensions) {
                    let allowedExtensions = response?.allowedExtensions;
                    setDisplayExtensions(allowedExtensions)
                    let allowedExtensionUpper = allowedExtensions.map(x => x.toUpperCase());
                    let allow = allowedExtensions.concat(allowedExtensionUpper);

                    setAllowedExtensions(allow)
                }
                if (response?.maxFileSize) {
                    setMaxFileSize(response.maxFileSize)
                }
        });
    }, []);

    const onChangeHandler = (event) => {
        if (event.newState && event.newState.length > 0) {
            let validationErrors = event.newState.map(x => x.validationErrors).filter(x => !!x);
            if (validationErrors && validationErrors.length > 0) {
                alertService.error('Fisierul incarcat nu este valid.');
            }
        }
        if (onChange) { onChange({ value: event.newState }); }
    };

    const onRemoveHandler = (event) => {
        if (onChange) { onChange({ value: event.newState }); }
    };

    return (<>
        <Upload
            {...others}
            accept={allowedExtensions.join(",")}
            autoUpload={false}
            showActionButtons={false}
            files={value}
            onAdd={onChangeHandler}
            onRemove={onRemoveHandler}
            restrictions={{
                allowedExtensions: allowedExtensions,
                maxFileSize: maxFileSize,
            }}
            defaultFiles={[]}
            multiple={multiple ? multiple : false}
        />

        {!hideInfo && <div className="clearfix mt10">
            <p className="pb5">Tipuri de fisiere acceptate:
                <span name="ext_file"> {displayExtensions.join(', ')}</span> <br />
                <span>Dimensiune maxima:</span>
                <span name="size_file">  {maxFileSize / 1024} </span> (Ko)</p>
        </div>}
    </>);
};